import { Controller, useFormContext } from 'react-hook-form';

import { Dropdown } from '@ui/components/Dropdown';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const OPTIONS = [
  {
    value: true,
    label: 'Удалить offline участников до жеребьевки',
  },
  { value: false, label: 'Ничего не делать' },
];

export function OnlineStatusInput() {
  const { control } = useFormContext<TournamentEditFormValues>();
  return (
    <FormRow>
      <FormLabel>Проверка Online</FormLabel>

      <FormInput>
        <Controller
          name="seedOnlyOnlineParticipants"
          control={control}
          defaultValue={true}
          render={({ field: { value, onChange, disabled } }) => {
            const onValidChange = (value: string) => {
              onChange(value === 'true');
            };
            return (
              <Dropdown
                options={OPTIONS}
                value={value ? 'true' : 'false'}
                onChange={onValidChange}
                disabled={disabled}
              />
            );
          }}
        />
      </FormInput>
    </FormRow>
  );
}
